import './App.css'
import SplashHeader from "./SplashHeader";
import MintSection from "./MintSection";
import {Roadmap} from "./Roadmap";

function App() {
  return (
    <div className="App">
      <SplashHeader />
      <MintSection />
    </div>
  )
}

export default App
